// @ts-expect-error not typed yet
import { callPrivateApi } from '@/api/apiHelper'
import { Studio, StudiosList, StudioUser, SearchParams, StudioEvent } from '@/modules/Studios/types'

export const fetchStudio = async (id: number | string): Promise<Studio> => callPrivateApi('get', `/studios/${id}`)
export const updateStudio = async (studio: Studio): Promise<Studio> =>
  callPrivateApi('put', `/studios/${studio.id}`, studio)
export const fetchStudiosList = async ({
  pageNumber: p,
  pageSize: pp,
  userId,
  keyword,
}: {
  pageNumber: number
  pageSize: number
  userId?: number
  keyword?: string
}): Promise<StudiosList> => callPrivateApi('get', '/studios', { params: { p, pp, userId, keyword } })

export const fetchStudiosMapList = async ({
  pageNumber: p,
  pageSize: pp,
  keyword,
  userCoords: uc,
  visibleMap,
}: SearchParams): Promise<StudiosList> =>
  callPrivateApi('get', '/studios-map', { params: { p, pp, keyword, uc, ...visibleMap } })

export const createStudio = async (): Promise<number> => callPrivateApi('post', '/studios')

export const publishStudio = async (studioId: number): Promise<string> =>
  callPrivateApi('put', `/studios/${studioId}/publish`)

export const unpublishStudio = async (studioId: number): Promise<string> =>
  callPrivateApi('put', `/studios/${studioId}/deactivate`)

export const deleteStudio = async (studioId: number): Promise<string> =>
  callPrivateApi('delete', `/studios/${studioId}`)

export const fetchStudioStudents = async (
  studioId: number,
  { pageNumber, pageSize, keyword, sortBy, sortDir }: SearchParams
): Promise<StudioUser[]> => {
  const params = {
    p: pageNumber,
    pp: pageSize,
    keyword,
    sortBy: `${sortBy}-${sortDir}`,
  }
  return callPrivateApi('get', `/studios/${studioId}/students`, { params })
}

export const deleteStudioStudentById = async (studioId: number, userId: number): Promise<string> =>
  callPrivateApi('delete', `/studios/${studioId}/students/${userId}`)

export const addStudioStudent = async (studioId: number, userId: number) =>
  callPrivateApi<StudioUser[]>('post', `/studios/${studioId}/students/${userId}`)

export const addStudioAdmin = async (studioId: number, userId: number) =>
  callPrivateApi<StudioUser[]>('post', `/studios/${studioId}/admins/${userId}`)

export const removeStudioAdmin = async (studioId: number, userId: number) =>
  callPrivateApi<StudioUser[]>('delete', `/studios/${studioId}/admins/${userId}`)

export const fetchStudioTeachers = async (
  studioId: number,
  { pageNumber, pageSize, keyword, sortBy, sortDir }: SearchParams
): Promise<StudioUser[]> => {
  const params = {
    p: pageNumber,
    pp: pageSize,
    keyword,
    sortBy: `${sortBy}-${sortDir}`,
  }
  return callPrivateApi('get', `/studios/${studioId}/teachers`, { params })
}

export const deleteStudioTeacherById = async (studioId: number, userId: number): Promise<string> =>
  callPrivateApi('delete', `/studios/${studioId}/teachers/${userId}`)

export const addStudioTeacher = async (studioId: number, userId: number) =>
  callPrivateApi<StudioUser[]>('post', `/studios/${studioId}/teachers/${userId}`)

export const fetchStudioCompetitions = async (
  studioId: number,
  { pageNumber, pageSize, keyword, sortBy, sortDir }: SearchParams
): Promise<StudioEvent[]> => {
  const params = {
    p: pageNumber,
    pp: pageSize,
    keyword,
    sortBy: `${sortBy}-${sortDir}`,
  }
  return callPrivateApi('get', `/studios/${studioId}/events`, { params })
}
